export { default } from "./CheckBox-component";
